import React from 'react';

import { RewardsPage } from 'features/reward/RewardsPage';
import { useEnableLoyaltyServiceRewards } from 'features/reward/hooks/use-enable-loyalty-service-rewards';
import { useStoreContext } from 'features/store';

import { useExposeRenderReadyOffersRewardsExperiment } from 'experiments/use-render-ready-offers-rewards-experiment';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { LoyaltyIncentiveCooldownMessage } from 'pages/loyalty/loyalty-incentives-components/loyalty-incentive-cooldown-message';
import LoyaltyRewards from 'pages/loyalty/loyalty-rewards/loyalty-rewards';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';

function Rewards() {
  const { noStoreSelected } = useStoreContext();
  const {
    enabled: enableLoyaltyServiceRewards,
    eligibleForExposure,
  } = useEnableLoyaltyServiceRewards();

  useExposeRenderReadyOffersRewardsExperiment(eligibleForExposure && !noStoreSelected);

  if (enableLoyaltyServiceRewards) {
    return <RewardsPage />;
  }

  return <LegacyRewards />;
}

const LegacyRewards = React.memo(() => {
  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyRewards />
      <LoyaltyIncentiveCooldownMessage incentiveType={LoyaltyPromotionType.REWARD} />
    </>
  );
});

export default React.memo(Rewards);
